import { z } from 'zod'

const SettlementExportStatusSchema = z.enum(['Created', 'Processing', 'Finished', 'Failed'])
export type SettlementExportStatus = z.infer<typeof SettlementExportStatusSchema>

export const SettlementExportRecordSchema = z.object({
  id: z.number(),
  system: z.number(),
  digital_twin: z.number().nullable(),
  /** Stockholm offset (`+02:00`), not `Z` — parse before comparing, never compare the strings. */
  start_time: z.string(),
  /** Exclusive. */
  end_time: z.string(),
  status: SettlementExportStatusSchema,
  /** `""` until the export is Finished, never `null`. */
  file_name: z.string(),
  file_size_bytes: z.number().nullable(),
  masterdata_file_name: z.string(),
  created_by: z.number().nullable(),
  /**
   * "First Last". Null when the user was deleted or has no name — deliberately no email fallback.
   * Optional as well, because a backend from before aurora-django#3621 sends `created_by_email`
   * instead, with no `creator_name` key, and requiring it would fail every list response there.
   */
  creator_name: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
  /** Reset on every retry attempt. */
  started_at: z.string().nullable(),
  finished_at: z.string().nullable(),
})
export type SettlementExportRecord = z.infer<typeof SettlementExportRecordSchema>

/**
 * The channel is public, so the payload names which export moved and nothing else. Everything
 * else comes from refetching the list through the authenticated API.
 */
export const SettlementExportUpdatedEventSchema = z.object({
  id: z.number(),
  status: SettlementExportStatusSchema,
})
export type SettlementExportUpdatedEvent = z.infer<typeof SettlementExportUpdatedEventSchema>

export type CreateSettlementExportBody = {
  system: number
  /** ISO 8601 with an explicit offset. Inclusive. */
  start_time: ISODateTime
  /** ISO 8601 with an explicit offset. Exclusive. */
  end_time: ISODateTime
}

/** Filters on when an export was requested (`created_at`), not on the period it covers. */
export type SettlementExportListWindow = {
  /** Inclusive. */
  createdAfter: ISODateTime
  /** Exclusive. */
  createdBefore: ISODateTime
}
